module.exports = __webpack_public_path__ + "img/wastebox_green.min.12fd7ba2.png";